<template lang="pug">
v-app
  .header-video.brand-dark-blue.white--text.hidden-sm-and-down.py-5.px-8.fill-width
    k-container.pa-0
      .d-flex.align-center
        // Kintell logo
        .d-flex.align-center
          k-icon(color="white" size="30").pr-3 kintell
          span.paragraph--semi-medium.font-weight-semibold.mr-4 Kintell
        v-spacer
        .justify-end.align-center.d-flex
          // Users profile image with the text My Kintell with the hover menu
          nuxt-link(:to="'/my-kintell/dashboard'" target="_blank").logged-in-user.unstyled--link
            k-user-avatar(:src="authenticatedUser.avatarUrl" :size="36")
            span.pl-4.vertical-align-middle.font-weight-bold.brand-light-pink--text My Dashboard
  v-main
    nuxt
</template>

<script>
import { UsesAuthenticatedUser } from '@/mixins'

export default {
  mixins: [
    UsesAuthenticatedUser
  ]
}
</script>

<style lang="scss" scoped>
$toolbar-height: 62px;


.v-application--wrap {
  background-color: var(--v-grey-1-base) !important;
}

.v-application,
.v-main {
  background-color: transparent !important;
}

.v-application::before {
  background-color: var(--v-grey-1-base);
  content: '';
  display: block;
  height: 100%;
  position: fixed;
  width: 100%;
  z-index: -1;
}

.v-main {
  @include sm-and-down {
    // 100vh - toolbar + footer line
    height: calc(100% - #{$toolbar-height} + 1px);
  }

  ::v-deep &__wrap {
    display: flex;
    flex-direction: column;
  }
}
</style>

<style>
/* stylelint-disable selector-max-id */

/*
  For video height, everything except body must have height: 100%
  meeting.vue will set this with js on mount
*/

html,
#__nuxt,
#__layout,
.v-application,
.v-application--wrap {
  height: 100%;
}

html,
body,
#__nuxt,
#__layout,
.v-application,
.v-application--wrap {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  min-height: 100%;
}
</style>
